export const fsModalDialogFooterLayoutSwapBreakpoint = {
    'extra-small': 'extra-small',
    small: 'small',
    medium: 'medium',
    large: 'large',
    'extra-large': 'extra-large'
};
export const fsModalDialogMobileLayout = {
    auto: 'auto',
    fullscreen: 'fullscreen'
};
export const fsModalDialogSize = {
    small: 'small',
    medium: 'medium',
    large: 'large'
};
export const fsModalDialogDismissibleClass = 'fs-modal-dialog--dismissible';
export const fsModalDialogOpenClass = 'fs-modal-dialog--open';
export const fsModalDialogScrollableClass = 'fs-modal-dialog--scrollable';
export const fsModalDialogWindowBodyElementScrolledToTopIntersectionTrackerClass = 'fs-modal-dialog__body-scroll-tracker--top';
export const fsModalDialogWindowBodyElementScrolledToBottomIntersectionTrackerClass = 'fs-modal-dialog__body-scroll-tracker--bottom';
export const fsModalDialogWindowHeaderScrollableIndicatorVisibleClass = 'fs-modal-dialog__header--scrollable-indicator-visible';
export const fsModalDialogWindowFooterScrollableIndicatorVisibleClass = 'fs-modal-dialog__footer--scrollable-indicator-visible';
/**
 * Acts as the default configuration for instances of ModalDialog
 */
export const fsModalDialogDefaults = {
    dismissible: false,
    footerLayoutSwapBreakpoint: undefined,
    mobileLayout: fsModalDialogMobileLayout.auto,
    open: false,
    scrollable: false,
    size: fsModalDialogSize.small,
    accessibleTitle: null
};
//# sourceMappingURL=IFsModalDialog.js.map